module.exports = {
	"global": {
		"true": "Yes",
		"false": "No",
		"edit": "EDIT",
		"intentionally-left-blank": "You can use this account to login to the app"
	},
	"menu": {
		"home": "Home",
		"change-profile": "Profile",
		"change-password": "Change password",
		"logout": "Log out",
		"default": "Default",
		"set_as_default": "Set as default"
	},
	"loginpage": {
		"login-title": "Zehnder portal login",
		"username-placeholder": "Username",
		"password-placeholder": "Password",
		"forgot-password": "Forgot password?",
		"login-button": "LOGIN"
	},
	"backendselectorpage": {
		"title": "Please select a product",
		"rememberchoice": "Set as default"
	},
	"homepage": {
		"nav": {
			"home": "Home",
			"mypresets": "My Presets",
			"logs": "Logfiles"
		},
		"filter-placeholder": "Search by name",
		"add-new-button": "ADD NEW",
		"title-edit-variant": "Edit variant",
		"tabs": {
			"installer-companies-tab": "INSTALLER COMPANIES",
			"add-installer-company-tab": "ADD INSTALLER COMPANY",
			"installers-tab": "INSTALLERS",
			"add-installer-tab": "ADD INSTALLER",
			"commercial-offers-tab": "COMMERCIAL OFFERS",
			"filter-shops-tab": "FILTER SHOPS",
			"products-tab": "MANAGE PRODUCTS",
			"add-product-tab": "ADD PRODUCT",
			"add-variant-tab": "ADD VARIANT",
			"softwareVersions-tab": "MANAGE FIRMWARE",
			"add-softwareVersion-tab": "ADD FIRMWARE",
			"installer-tab": "INSTALLER",
			"documents-tab": "DOCUMENTS"
		},
		"table-headers": {
			"username": "USERNAME",
			"email": "EMAIL",
			"country2": "COUNTRY",
			"companyName": "COMPANY NAME",
			"address": "ADDRESS",
			"phonenumber": "PHONENUMBER",
			"something": "SOMETHING",
			"productID": "PRODUCT_ID",
			"version": "VERSION",
			"releaseNotes": "RELEASE NOTES",
			"name": "NAME",
			"edit": " ",
			"edit-header": "",
			"beta2": "BETA",
			"productName": "PRODUCT"
		},
		"installer-editor": {
			"add-installer": "Add installer",
			"edit-installer": "Edit installer",
			"save-button": "Save",
			"cancel-button": "Cancel",
			"username-label": "Username",
			"email-label": "Email address",
			"phone-label": "Phonenumber",
			"delete-label": "Delete",
			"delete-title": "Deleting an installer!",
			"change-password-title": "Changing password",
			"new-password-label": "New password",
			"new-password-placeholder": "New password",
			"confirm-password-label": "Confirm password",
			"confirm-password-placeholder": "Confirm password"
		},
		"installer-company-editor": {
			"add-installer-company": "Add installer company",
			"edit-installer-company": "Edit installer company",
			"save-button": "Save",
			"cancel-button": "Cancel",
			"username-label": "Username",
			"email-label": "Email address",
			"companyName-label": "Company name",
			"address-label": "Address",
			"country-label": "Country",
			"delete-label": "Delete",
			"delete-title": "Deleting an installer company!",
			"change-password-title": "Changing password",
			"beta-label": "Beta",
			"new-password-label": "New password",
			"new-password-placeholder": "New password",
			"confirm-password-label": "Confirm password",
			"confirm-password-placeholder": "Confirm password",
			"you-are-about-to-delete": "You are about to delete ",
			"sure": "Are you sure?",
			"empty-ic-name": "Please enter the name of the company",
			"invalid-email": "Invalid email",
			"pick": "Choose one...",
			"email-confirm-label": "Confirm email address",
			"email-confirm-incorrect": "Email addresses do not match"
		},
		"commercial-offers": {
			"title": "Commercial Offers",
			"save-button": "Save changes",
			"activation-date-placeholder": "Activation date",
			"end-date-placeholder": "End date"
		},
		"filter-shops": {
			"title": "Filtershops",
			"save-button": "Save changes"
		},
		"product-editor": {
			"add-product": "Add product",
			"edit-product": "Edit product",
			"save-button": "Save",
			"cancel-button": "Cancel",
			"delete-label": "Delete",
			"productID-label": "Product ID",
			"name-label": "Productname",
			"articlePrefix-label": "Article prefix",
			"table-headers": {
				"variantID": "VARIANT_ID",
				"name": "NAME",
				"edit": "EDIT"
			},
			"filter-placeholder": "Search by name",
			"add-new-button": "ADD VARIANT",
			"add-variant": "Add variant",
			"edit-variant": "Edit variant",
			"delete-title": "Deleting a product!"
		},
		"softwareVersion-editor": {
			"add-softwareVersion": "Add firmware version",
			"edit-softwareVersion": "Edit firmware version",
			"filter-placeholder": "Search",
			"delete-label": "Delete firmware version",
			"version-label": "Version",
			"releaseNotes-label": "Release notes",
			"product-label": "product",
			"save-button": "Save",
			"cancel-button": "Cancel",
			"delete-title": "Deleting a firmwareversion!",
			"name-label": "Name",
			"md5-label": "Md5",
			"choose-binary": "Choose binary",
			"binary-label": "Binary",
			"beta-label": "Beta",
			"country-label": "Country",
			"table-headers": {
				"blockID": "BlockID",
				"name": "name",
				"url": "url",
				"size": "size",
				"md5": "md5",
				"articleIDs": "articles",
				"edit": "edit",
				"delete": "delete"
			}
		},
		"documents-panel": {
			"title": "Documents",
			"add-new-button": "Add new",
			"documents-list": {
				"delete-label": "Delete",
				"delete-title": "Deleting document",
				"save-button": "Save",
				"cancel-button": "Cancel"
			},
			"download": "Download"
		},
		"document-editor": {
			"add-document": "Add document",
			"save-button": "Save",
			"cancel-button": "Cancel",
			"name-label": "Name",
			"description-label": "Description",
			"type-label": "Type",
			"url-label": "URL",
			"file-label": "File",
			"choose-file": "Choose file",
			"model-label": "Model",
			"country-label": "Country",
			"tabs": {
				"url-tab": "URL",
				"upload-tab": "FILE"
			},
			"no-name-entered": "Please enter the name of the document",
			"no-description-entered": "Please enter the description of the document"
		}
	},
	"passwordpage": {
		"nav": {
			"home": "Home",
			"mypresets": "My Presets",
			"logs": "Logfiles"
		},
		"title": "Change password",
		"new-password-placeholder": "New password",
		"confirm-password-placeholder": "Confirm password"
	},
	"forgotpasswordpage": {
		"title": "Change password request",
		"email-label": "Email address",
		"send-email-button": "Send email",
		"password-requested-message": "Password request email sent to"
	},
	"changepasswordpage": {
		"title": "Change password",
		"current-password-label": "Current password",
		"current-password-placeholder": "Current password",
		"new-password-label": "New password",
		"new-password-placeholder": "New password",
		"confirm-password-label": "Confirm password",
		"confirm-password-placeholder": "Confirm password",
		"save-button": "Change password",
		"cancel-button": "Cancel",
		"change-password-label": "Change password",
		"change-password-description": "The password must be at least 8 characters long and contain 1 letter, 1 number, 1 capital letter and a special character.",
		"change-password-current": "Please enter your current password.",
		"change-password-confirm": "Please confirm your new password."
	},
	"profilepage": {
		"title": "Profile page",
		"companyName-label": "Company name",
		"email-label": "Email",
		"address-label": "Address",
		"language-label": "Preferred language",
		"save-button": "Save",
		"cancel-button": "Cancel"
	},
	"country": {
		"BELGIUM": "Belgium",
		"NETHERLANDS": "The Netherlands",
		"GERMANY": "Germany",
		"UNITED_KINGDOM": "United kingdom",
		"FRANCE": "France",
		"AUSTRIA": "Austria",
		"POLAND": "Poland",
		"SWITZERLAND": "Switzerland",
		"ITALY": "Italy",
		"SPAIN": "Spain",
		"NORTH_AMERICA": "North America",
		"ALL_COUNTRIES": "All",
		"OTHER_COUNTRIES": "Other countries"
	},
	"table": {
		"no-data-message": "No data available"
	},
	"error": {
		"login": {
			"invalid": "Username and/or password incorrect.",
			"error": "Error connecting to server.",
			"no_products": "This account does not have access to a Zehnder product."
		},
		"password": {
			"change-failed": "Changing password failed",
			"update-failed": "You are not logged in or you do not use the same browser you used to request the password change",
			"user-not-found": "User with this email can not be found",
			"insecure": "Password must be at least 8 characters and contain 1 letter, 1 number, 1 capital letter and a special character",
			"too-short": "Password must be at least 8 characters",
			"mismatch": "Current password is incorrect",
			"password-changed": "Password successfully changed",
			"dontmatch": "The passwords don't match",
			"password-not-changed": "The password you entered is the same as the one you try to change it to"
		},
		"manager": {
			"no-access": "You have no access to the manager information",
			"load-fail": "Failed loading manager data"
		},
		"installer": {
			"no-access": "You have no access to the installers",
			"load-fail": "Failed loading installers",
			"duplicate": "Installer with this email or username already exists",
			"wrong-company": "Installer exists but is associated with another company",
			"add-failed": "Adding installer failed",
			"update-failed": "Updating installer failed",
			"removed-failed": "Removing installer failed"
		},
		"installer-company": {
			"no-access": "You have no access to the installer companies",
			"load-fail": "Failed loading installer companies",
			"conflict": "The username and e-mail must be unique.",
			"duplicate": "Installer company with this email or username already exists",
			"add-failed": "Adding installer company failed",
			"update-failed": "Updating installer company failed",
			"removed-failed": "Removing installer company failed",
			"add-success": "Installer company created. Verification e-mail has been sent to the new user.",
			"password-change": {
				"no-access": "You can't change password of the installer company",
				"failed": "Password change failed",
				"success": "Password has been changed"
			}
		},
		"softwareversion": {
			"no-access": "You have no access to the softwareversions",
			"load-fail": "Failed loading softwareversions",
			"duplicate": "Softwareversions with this version already exists",
			"add-failed": "Adding Softwareversion failed",
			"update-failed": "Updating Softwareversion failed",
			"removed-failed": "Removing Softwareversion failed"
		},
		"product": {
			"no-access": "You have no access to the products",
			"load-fail": "Failed loading products",
			"add-failed": "Adding product failed",
			"update-failed": "Updating product failed",
			"removed-failed": "Removing product failed"
		},
		"commercial-offer": {
			"no-access": "You have no access to the commercial offers",
			"load-failed": "Failed loading commercial offers",
			"add-failed": "Adding commercial offer failed"
		},
		"filtershop": {
			"no-access": "You have no access to the filtershops",
			"load-failed": "Failed loading filtershops",
			"add-failed": "Adding filtershop failed"
		},
		"documents": {
			"no-access": "You have no access to the documents",
			"load-failed": "Failed loading documents",
			"add-failed": "Adding document failed",
			"change-position-fail": "Changing the order of documents failed",
			"invalid-url": "The URL is not valid"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// /locales/en.json
// module id = 1308
// module chunks = 0